var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.seeLog}},[_c('Header',{on:{"stickyUpdate":(val) => {
        _vm.stickyHeader = val;
      }}}),_c('SiteBanner'),_c('div',{staticClass:"content",class:{ sticky: _vm.stickyHeader }},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }